import memoizeOne from 'memoize-one';
import trimEnd from 'lodash/trimEnd';

export const sanitizeQueryString = memoizeOne((queryString) => {
  return trimEnd(queryString.replace(/(modal|speakerId|workshopId|userId)=[^&]+&?/g, ''), '&');
});
